module.exports = __webpack_public_path__ + "static/ZIMOWE WARSZTATY - FERIE 2024_compressed-be4ecfc9958cbac643c89fe1c7355750.pdf";